import memoizeLatest from 'memoize-one'

export default memoizeLatest
